import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChanges: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChanges"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM8.5 15V17H15.5V15H8.5ZM11 9H8.5V11H11V13.5H13V11H15.5V9H13V6.5H11V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChanges;
